import API from "@/API";

const SET_TYPE = "SET_TYPE";

export default {
  namespaced: true,

  state: {
    preloader: false,
    type: "physicals"
  },

  actions: {
    setType({ commit, state }, payload) {
      if (payload === state.type) return;
      commit("SET_TYPE", payload);
    },

    async sendVerificationEmail({ state }, account_id) {
      try {
        await API.Clients.sendVerificationEmail(account_id);
      } catch (e) {
        throw e;
      }
    },

    async searchByName({ commit }, payload) {
      try {
        return await API.Clients.searchByName(payload);
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {
    [SET_TYPE](state, payload) {
      state.type = payload;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/clients.js